import { reducer as app } from './modules/app';
import actionsReducer from './modules/actions';
import appendixReducer from './modules/appendix';
import approvalsReducer from './modules/approvals';
import externalOfferingsReducer from './modules/externalOfferings';
import formsReducer from './modules/forms';
import portfolioReducer from './modules/portfolio';
import requestsReducer from './modules/requests';
import searchReducer from './modules/search';
import serviceReducer from './modules/service';
import servicesAppReducer from './modules/servicesApp';
import submissionReducer from './modules/submission';
import settingsFormsReducer from './modules/settingsForms';
import settingsCategoriesReducer from './modules/settingsCategories';
import settingsAppendixReducer from './modules/settingsAppendix';
import settingsPortfolioReducer from './modules/settingsPortfolio';
import settingsServiceReducer from './modules/settingsService';

export default {
  app,
  actions: actionsReducer,
  appendix: appendixReducer,
  approvals: approvalsReducer,
  externalOfferings: externalOfferingsReducer,
  forms: formsReducer,
  portfolio: portfolioReducer,
  requests: requestsReducer,
  search: searchReducer,
  service: serviceReducer,
  servicesApp: servicesAppReducer,
  submission: submissionReducer,
  settingsForms: settingsFormsReducer,
  settingsCategories: settingsCategoriesReducer,
  settingsAppendix: settingsAppendixReducer,
  settingsPortfolio: settingsPortfolioReducer,
  settingsService: settingsServiceReducer,
};
